import { render } from "./MedicalRecordDetail.vue?vue&type=template&id=f12ca1c6&scoped=true"
import script from "./MedicalRecordDetail.vue?vue&type=script&lang=js"
export * from "./MedicalRecordDetail.vue?vue&type=script&lang=js"

import "./MedicalRecordDetail.vue?vue&type=style&index=0&id=f12ca1c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12ca1c6"]])

export default __exports__